
import AssignmentButton from "../assignment/AssignmentButton";
import QuizButton from "../quiz/QuizButton";
import {formatDate} from "../../../utils/commonUtility";
import {useGetVideoQuery} from "../../../features/video/videoApi";
import EmptyResult from "../../ui/EmptyResult";
import Loading from "../../ui/Loading";
import Error from "../../ui/Error";

export default function ActiveVideo({ videoId }) {
	const {
		data: video,
		isLoading,
		isError,
	} = useGetVideoQuery(videoId) || {};

	// Decide what to render
	let content = null;
	if (isLoading) {
		content = <Loading />;
	} 
	else if (!isLoading && isError) {
		content = <Error message="There was an error!" />;
	} 
	else if (!isLoading && !isError && video === undefined) {
		content = <EmptyResult contentName="video" />;
	} 
	else if (!isLoading && !isError && !!video) {
		const { id, url, title, createdAt, description } = video;
		const uploadedDate = formatDate(createdAt);

		content = (
			<>
				<iframe
					width="100%"
					className="aspect-video"
					src={url}
					title={title}
					frameBorder="0"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
					allowFullScreen
				></iframe>

				<div>
					<h1 className="text-lg font-semibold tracking-tight text-slate-100">
						{title}
					</h1>
					<h2 className=" pb-4 text-sm leading-[1.7142857] text-slate-400">
						Uploaded on {uploadedDate}
					</h2>

					<div className="flex gap-4">
						<AssignmentButton videoId={id} />
						<QuizButton videoId={id} />
					</div>
					<p className="mt-4 text-sm text-slate-400 leading-6">
						{description}
					</p>
				</div>
			</>
		);
	}

	return (
		<div className="col-span-full w-full space-y-8 lg:col-span-2">
			{content}
		</div>
	);
}
